import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	empty: {
		id: 'issue-navigator-action-pluggable-items.empty.empty',
		defaultMessage: 'There are no apps installed for the Issue Navigator',
		description:
			'No ecosystem apps that plug into the issue navigator are installed for this instance.',
	},
	emptyIssueTerminologyRefreshM4: {
		id: 'issue-navigator-action-pluggable-items.empty.empty-issue-terminology-refresh-m4',
		defaultMessage: 'There are no apps installed for the work item search',
		description:
			'No ecosystem apps that plug into the issue navigator are installed for this instance.',
	},
});
export default messages;
